module.exports = __webpack_public_path__ + "static/happy-kid-picture.e807e7f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/happy-kid-picture.jpg
// module id = 72
// module chunks = 35783957827783 95715928098905 264598414423048